    <div class="trendOverviewEach" style="margin:10px; display: block;">
      <div class="ui-g-12" style="font-size:20px; color: gray;">{{title}}</div>
      <div class="ui-g-12">
        <div class="ui-g-12 amount" style="text-align: right; font-weight: bold; font-family: 'Roboto', 'Trebuchet MS', 'Arial', 'Helvetica', sans-serif;">
          <span *ngIf="measurement_unit_position == 'before'">{{measurement_unit}} </span>
          <span *ngIf="type == 'float' && isNum(current)"> {{(current) | number:'1.2-2':'it' }}</span>
          <span *ngIf="type == 'int' && isNum(current)"> {{(current) | number:'1.0-0':'it' }}</span>
          <span *ngIf="measurement_unit_position == 'after'"> {{measurement_unit}}</span>
        </div>
      </div>
      <div class="ui-g-12" [ngStyle]="{'color': change < 0 ? 'red' : 'green'}">
        <strong *ngIf="isNum(change)">{{change > 0 ? '+' : ''}}{{(change) | number:'1.2-2':'it'}}%</strong>

        <i *ngIf="change > 0" class="fa fa-fw fa-chevron-up" [ngStyle]="{'color': 'green', 'font-size': '14px'}"></i>
        <i *ngIf="change == 0" class="fa fa-fw fa-pause fa-rotate-90" [ngStyle]="{'color': 'gray', 'font-size': '14px'}"></i>
        <i *ngIf="change < 0" class="fa fa-fw fa-chevron-down" [ngStyle]="{'color': 'red', 'font-size': '14px'}"></i>
      </div>
      <div class="ui-g-12" style="color: #20417b;">
        {{ 'customerBase.previous' | translate}}: <span *ngIf="measurement_unit_position == 'before'">{{measurement_unit}} </span>
        <strong *ngIf="type == 'float' && isNum(previous)"> {{previous | number:'1.2-2':'it'}}</strong>
        <strong *ngIf="type == 'int' && isNum(previous)">{{(previous) | number:'1.0-0':'it'}}</strong>
        <span *ngIf="measurement_unit_position == 'after'"> {{measurement_unit}}</span>
      </div>
    </div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-base/customer-base-card.component.html